/*! GhostStat Geo Analytics — zoomable drill map + leaderboard + table.
 *  Drill: World -> Continent -> Country -> Region -> City.
 *
 *  "EU" used to be faked as a country here. It isn't one: it is what MaxMind returns when an IP
 *  resolves no further than Europe. That case now lands where it belongs — on the continent tier —
 *  and the codes that resolve to no place at all (A1 anonymous proxy, A2 satellite, unknown) are
 *  reported in their own strip instead of being dropped or mislabelled. */
(function () {
  function TT(k){ return (window.GS&&GS.t)?GS.t(k):k; }
  "use strict";
  /* Answers "is the deployed file the new one?" without a deploy archaeology session. If the
     console does not say 1.4.1, a stale edge copy is being served — purge the CDN. */
  try { (window.GS_BUILD = window.GS_BUILD || {})["geo"] = "1.4.1"; } catch (e) {}
  if (window.__geoWired) return; window.__geoWired = 1;
  /* Answers "which geo.js is the browser actually running?" without a deploy archaeology session.
     If the console does not say 1.4.1, a stale copy is being served — purge the CDN. */
  window.GS_GEO_BUILD = "1.4.1";
  try { console.info("GhostStat Geo " + window.GS_GEO_BUILD); } catch (e) {}

  var NS = "http://www.w3.org/2000/svg";
  function E(t) { return document.createElementNS(NS, t); }
  function A(e, a) { for (var k in a) e.setAttribute(k, a[k]); return e; }
  var root, tip;
  function q(s) { return root ? root.querySelector('[data-g="' + s + '"]') : null; }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function siteParam() { return "site=" + encodeURIComponent((window.GS && GS.site) || ""); }
  function unwrap(r) { return (r && r.data && typeof r.data === "object") ? r.data : (r || {}); }
  var MON = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  function fmtDate(ts) { var m = String(ts || "").match(/^(\d{4})-(\d{2})-(\d{2})/); return m ? (MON[+m[2] - 1] + " " + (+m[3]) + ", " + m[1]) : "\u2014"; }
  function ready(fn) {
    function ok() { return window.GS && GS.api && GS.site; }
    var done = false; function go() { if (done) return; done = true; fn(); }
    if (ok()) { go(); return; }
    var n = 0, t = setInterval(function () { if (ok()) { clearInterval(t); go(); } else if (++n > 300) clearInterval(t); }, 30);
    document.addEventListener("gs:ready", function () { if (ok()) { clearInterval(t); go(); } }, { once: true });
  }

  var DN = null; try { DN = new Intl.DisplayNames(["en"], { type: "region" }); } catch (e) {}
  function cname(code) { try { return (DN && DN.of(code)) || code; } catch (e) { return code; } }
  function flag(code) { code = String(code || "").toUpperCase(); if (!/^[A-Z]{2}$/.test(code)) return "\u{1F3F3}"; return code.replace(/./g, function (c) { return String.fromCodePoint(127397 + c.charCodeAt(0)); }); }
  function secs(s) { s = +s || 0; if (s < 60) return s + "s"; var m = Math.floor(s / 60), r = s % 60; return m + "m" + (r ? " " + r + "s" : ""); }

  /* ---- continents. Mirrors GeoCodes::CONTINENTS server-side. ---- */
  var CONT = {
    AF: { name: T("geo.cont.africa"), map: "africa-merc", emoji: "\u{1F30D}" },
    AN: { name: T("geo.cont.antarctica"), map: null, emoji: "\u{1F9CA}" },
    AS: { name: T("geo.cont.asia"), map: "asia-merc", emoji: "\u{1F30F}" },
    EU: { name: T("geo.cont.eu"), map: "europe-merc", emoji: "\u{1F30D}" },
    NA: { name: T("geo.cont.na"), map: "north-america-merc", emoji: "\u{1F30E}" },
    OC: { name: T("geo.cont.oceania"), map: "oceania-merc", emoji: "\u{1F30F}" },
    SA: { name: T("geo.cont.sa"), map: "south-america-merc", emoji: "\u{1F30E}" },
    // APNIC's registry region: real information (T('geo.somewhere_apac')), but not a landmass.
    // No map, never drilled — the table row carries a badge saying exactly that.
    AP: { name: T("geo.cont.apac"), map: null, emoji: "\u{1F4E1}" }
  };
  function contName(c) { return (CONT[c] && CONT[c].name) || T("geo.unknown"); }
  function contEmoji(c) { return (CONT[c] && CONT[c].emoji) || "\u{1F310}"; }

  var REG = { US: { AL: "Alabama", AK: "Alaska", AZ: "Arizona", AR: "Arkansas", CA: "California", CO: "Colorado", CT: "Connecticut", DE: "Delaware", DC: "District of Columbia", FL: "Florida", GA: "Georgia", HI: "Hawaii", ID: "Idaho", IL: "Illinois", IN: "Indiana", IA: "Iowa", KS: "Kansas", KY: "Kentucky", LA: "Louisiana", ME: "Maine", MD: "Maryland", MA: "Massachusetts", MI: "Michigan", MN: "Minnesota", MS: "Mississippi", MO: "Missouri", MT: "Montana", NE: "Nebraska", NV: "Nevada", NH: "New Hampshire", NJ: "New Jersey", NM: "New Mexico", NY: "New York", NC: "North Carolina", ND: "North Dakota", OH: "Ohio", OK: "Oklahoma", OR: "Oregon", PA: "Pennsylvania", RI: "Rhode Island", SC: "South Carolina", SD: "South Dakota", TN: "Tennessee", TX: "Texas", UT: "Utah", VT: "Vermont", VA: "Virginia", WA: "Washington", WV: "West Virginia", WI: "Wisconsin", WY: "Wyoming" }, CA: { AB: "Alberta", BC: "British Columbia", MB: "Manitoba", NB: "New Brunswick", NL: "Newfoundland and Labrador", NS: "Nova Scotia", NT: "Northwest Territories", NU: "Nunavut", ON: "Ontario", PE: "Prince Edward Island", QC: "Quebec", SK: "Saskatchewan", YT: "Yukon" } };
  /* Display label for a stored region code. Falls back to the raw code rather than inventing a
     name: "06" is at least true, whereas a wrong province name is not. */
  function regionName(country, code) {
    if (code == null) return "";
    var s = regRaw(country, code); if (s) return s;
    var id = subCode(country, code);
    return (id && subName(country, id)) || String(code);
  }

  var C = { US: [-98, 39], CA: [-106, 56], MX: [-102, 23], BR: [-51, -10], AR: [-64, -34], CL: [-71, -35], CO: [-74, 4], PE: [-75, -10], GB: [-2, 54], IE: [-8, 53], FR: [2, 46], ES: [-4, 40], PT: [-8, 39], DE: [10, 51], NL: [5, 52], BE: [4, 50], CH: [8, 47], IT: [12, 42], AT: [14, 47], PL: [19, 52], SE: [15, 62], NO: [9, 61], FI: [26, 64], DK: [10, 56], CZ: [15, 50], GR: [22, 39], RO: [25, 46], HU: [19, 47], UA: [32, 49], RU: [90, 61], TR: [35, 39], IL: [35, 31], SA: [45, 24], AE: [54, 24], EG: [30, 27], ZA: [24, -29], NG: [8, 10], KE: [38, 0], MA: [-6, 32], IN: [79, 22], PK: [70, 30], BD: [90, 24], CN: [104, 35], JP: [138, 37], KR: [128, 36], TW: [121, 24], HK: [114, 22], TH: [101, 15], VN: [106, 16], PH: [122, 13], ID: [118, -2], MY: [102, 4], SG: [104, 1], AU: [134, -25], NZ: [172, -41] };
  var MW = 720, MH = 360;
  function px(lon) { return (lon + 180) / 360 * MW; }
  function py(lat) { return (90 - lat) / 180 * MH; }

  /* level: continent | country | region | city */
  var STATE = { level: "continent", continent: null, country: null, region: null };

  /* Deep links, so other pages can hand off a place:
       /geo?continent=EU
       /geo?country=US                 -> that country's regions
       /geo?country=US&region=CA       -> that region's cities
       /geo?country=US&region=CA&city=San+Jose  -> zooms and opens the visitor panel
     Pure function, so it is testable without a browser. `continent` may be omitted: the regions
     and cities endpoints return the country's continent, and STATE is filled in from the response
     rather than from a country->continent table duplicated in JS. */
  function parseDeepLink(search) {
    var p; try { p = new URLSearchParams(search || ""); } catch (e) { return null; }
    var clean = function (v, re) { v = String(v == null ? "" : v).trim(); return re.test(v) ? v : ""; };
    var cont = clean((p.get("continent") || "").toUpperCase(), /^[A-Z]{2}$/);
    var co   = clean((p.get("country") || "").toUpperCase(), /^[A-Z]{2}$/);
    var re   = String(p.get("region") || "").trim().slice(0, 80);
    var ci   = String(p.get("city") || "").trim().slice(0, 120);

    if (co) {
      if (re && ci) return { level: "city", continent: cont || null, country: co, region: re, city: ci };
      if (re)       return { level: "city", continent: cont || null, country: co, region: re, city: null };
      return { level: "region", continent: cont || null, country: co, region: null, city: null };
    }
    if (cont && CONT[cont]) return { level: "country", continent: cont, country: null, region: null, city: null };
    return null;
  }

  var PENDING_CITY = null;

  /* Keep the address bar in step with the drill, so any view can be linked to or reloaded. */
  function writeUrl() {
    if (!window.history || !history.replaceState) return;
    var p = [];
    if (STATE.continent) p.push("continent=" + encodeURIComponent(STATE.continent));
    if (STATE.country)   p.push("country=" + encodeURIComponent(STATE.country));
    if (STATE.region)    p.push("region=" + encodeURIComponent(STATE.region));
    try { history.replaceState(null, "", location.pathname + (p.length ? "?" + p.join("&") : "")); } catch (e) {}
  }
  var CONTINENTS = null, COUNTRIES = null;

  /* ---- zoomable drill map (jsVectorMap) — self-painted blue choropleth ---- */
  var BUILTIN_SUBMAP = {"US": {"map": "us-aea", "c2n": {"US-AL": "Alabama", "US-AK": "Alaska", "US-AZ": "Arizona", "US-AR": "Arkansas", "US-CA": "California", "US-CO": "Colorado", "US-CT": "Connecticut", "US-DE": "Delaware", "US-DC": "District of Columbia", "US-FL": "Florida", "US-GA": "Georgia", "US-HI": "Hawaii", "US-ID": "Idaho", "US-IL": "Illinois", "US-IN": "Indiana", "US-IA": "Iowa", "US-KS": "Kansas", "US-KY": "Kentucky", "US-LA": "Louisiana", "US-ME": "Maine", "US-MD": "Maryland", "US-MA": "Massachusetts", "US-MI": "Michigan", "US-MN": "Minnesota", "US-MS": "Mississippi", "US-MO": "Missouri", "US-MT": "Montana", "US-NE": "Nebraska", "US-NV": "Nevada", "US-NH": "New Hampshire", "US-NJ": "New Jersey", "US-NM": "New Mexico", "US-NY": "New York", "US-NC": "North Carolina", "US-ND": "North Dakota", "US-OH": "Ohio", "US-OK": "Oklahoma", "US-OR": "Oregon", "US-PA": "Pennsylvania", "US-RI": "Rhode Island", "US-SC": "South Carolina", "US-SD": "South Dakota", "US-TN": "Tennessee", "US-TX": "Texas", "US-UT": "Utah", "US-VT": "Vermont", "US-VA": "Virginia", "US-WA": "Washington", "US-WV": "West Virginia", "US-WI": "Wisconsin", "US-WY": "Wyoming"}, "n2c": {"alabama": "US-AL", "alaska": "US-AK", "arizona": "US-AZ", "arkansas": "US-AR", "california": "US-CA", "colorado": "US-CO", "connecticut": "US-CT", "delaware": "US-DE", "districtofcolumbia": "US-DC", "florida": "US-FL", "georgia": "US-GA", "hawaii": "US-HI", "idaho": "US-ID", "illinois": "US-IL", "indiana": "US-IN", "iowa": "US-IA", "kansas": "US-KS", "kentucky": "US-KY", "louisiana": "US-LA", "maine": "US-ME", "maryland": "US-MD", "massachusetts": "US-MA", "michigan": "US-MI", "minnesota": "US-MN", "mississippi": "US-MS", "missouri": "US-MO", "montana": "US-MT", "nebraska": "US-NE", "nevada": "US-NV", "newhampshire": "US-NH", "newjersey": "US-NJ", "newmexico": "US-NM", "newyork": "US-NY", "northcarolina": "US-NC", "northdakota": "US-ND", "ohio": "US-OH", "oklahoma": "US-OK", "oregon": "US-OR", "pennsylvania": "US-PA", "rhodeisland": "US-RI", "southcarolina": "US-SC", "southdakota": "US-SD", "tennessee": "US-TN", "texas": "US-TX", "utah": "US-UT", "vermont": "US-VT", "virginia": "US-VA", "washington": "US-WA", "westvirginia": "US-WV", "wisconsin": "US-WI", "wyoming": "US-WY"}}, "CA": {"map": "ca-lcc", "c2n": {"CA-NT": "Northwest Territories", "CA-NU": "Nunavut", "CA-NS": "Nova Scotia", "CA-BC": "British Columbia", "CA-SK": "Saskatchewan", "CA-QC": "Qu\u00e9bec", "CA-PE": "Prince Edward Island", "CA-MB": "Manitoba", "CA-YT": "Yukon", "CA-NB": "New Brunswick", "CA-NL": "Newfoundland and Labrador", "CA-ON": "Ontario", "CA-AB": "Alberta"}, "n2c": {"northwestterritories": "CA-NT", "nunavut": "CA-NU", "novascotia": "CA-NS", "britishcolumbia": "CA-BC", "saskatchewan": "CA-SK", "quebec": "CA-QC", "princeedwardisland": "CA-PE", "manitoba": "CA-MB", "yukon": "CA-YT", "newbrunswick": "CA-NB", "newfoundlandandlabrador": "CA-NL", "ontario": "CA-ON", "alberta": "CA-AB", "yukonterritory": "CA-YT", "newfoundland": "CA-NL"}}, "NL": {"map": "nl-mill", "c2n": {"NL-OV": "Overijssel", "NL-FR": "Friesland", "NL-UT": "Utrecht", "NL-GE": "Gelderland", "NL-FL": "Flevoland", "NL-NH": "Noord-Holland", "NL-ZE": "Zeeland", "NL-ZH": "Zuid-Holland", "NL-GR": "Groningen", "NL-DR": "Drenthe", "NL-NB": "Noord-Brabant", "NL-LI": "Limburg"}, "n2c": {"overijssel": "NL-OV", "friesland": "NL-FR", "utrecht": "NL-UT", "gelderland": "NL-GE", "flevoland": "NL-FL", "noordholland": "NL-NH", "zeeland": "NL-ZE", "zuidholland": "NL-ZH", "groningen": "NL-GR", "drenthe": "NL-DR", "noordbrabant": "NL-NB", "limburg": "NL-LI", "northholland": "NL-NH", "southholland": "NL-ZH", "northbrabant": "NL-NB", "fryslan": "NL-FR"}}, "DE": {"map": "de-mill", "c2n": {"DE-BE": "Berlin", "DE-ST": "Sachsen-Anhalt", "DE-RP": "Rheinland-Pfalz", "DE-BB": "Brandenburg", "DE-NI": "Niedersachsen", "DE-MV": "Mecklenburg-Vorpommern", "DE-TH": "Th\u00fcringen", "DE-BW": "Baden-W\u00fcrttemberg", "DE-HH": "Hamburg", "DE-SH": "Schleswig-Holstein", "DE-NW": "Nordrhein-Westfalen", "DE-SN": "Sachsen", "DE-HB": "Bremen", "DE-SL": "Saarland", "DE-BY": "Bayern", "DE-HE": "Hessen"}, "n2c": {"berlin": "DE-BE", "sachsenanhalt": "DE-ST", "rheinlandpfalz": "DE-RP", "brandenburg": "DE-BB", "niedersachsen": "DE-NI", "mecklenburgvorpommern": "DE-MV", "thuringen": "DE-TH", "badenwurttemberg": "DE-BW", "hamburg": "DE-HH", "schleswigholstein": "DE-SH", "nordrheinwestfalen": "DE-NW", "sachsen": "DE-SN", "bremen": "DE-HB", "saarland": "DE-SL", "bayern": "DE-BY", "hessen": "DE-HE", "bavaria": "DE-BY", "lowersaxony": "DE-NI", "northrhinewestphalia": "DE-NW", "rhinelandpalatinate": "DE-RP", "saxony": "DE-SN", "saxonyanhalt": "DE-ST", "thuringia": "DE-TH", "hesse": "DE-HE", "mecklenburgwesternpomerania": "DE-MV"}}};
  var SUBMAP=(function(){var m={},k;for(k in BUILTIN_SUBMAP)m[k]=BUILTIN_SUBMAP[k];var g=window.GS_GEO_SUBMAPS||{};for(k in g)m[k]=g[k];return m;})();
  function normName(s){ try{ return String(s).toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g,"").replace(/[^a-z0-9]/g,""); }catch(e){ return String(s).toLowerCase().replace(/[^a-z0-9]/g,""); } }
  function mapReady(name){ return !!name && (!window.GS_GEO_MAPS || window.GS_GEO_MAPS.indexOf(name)>=0); }
  var LOADEDMAPS={world:1,"world-merc":1};
  function ensureMap(name){ return new Promise(function(res){
    if(!name || name==="world" || LOADEDMAPS[name]){ res(!!name||name==="world"); return; }
    if(window.GS_GEO_MAPS && window.GS_GEO_MAPS.indexOf(name)<0){ res(false); return; }
    var base=window.GS_GEO_MAPS_BASE; if(!base){ res(false); return; }
    var sc=document.createElement("script"); sc.src=base+"/"+name+".js"+(window.GS_GEO_VER?("?v="+window.GS_GEO_VER):""); sc.async=false;
    sc.onload=function(){ LOADEDMAPS[name]=1; res(true); }; sc.onerror=function(){ res(false); };
    document.head.appendChild(sc); }); }
  function subFor(cc){ var r=SUBMAP[cc]; return (r && mapReady(r.map)) ? r : null; }
  function contMap(code){ var m=CONT[code] && CONT[code].map; return mapReady(m) ? m : null; }
  /* MaxMind Legacy stores ISO/USPS two-letter region codes for the US and Canada, and FIPS 10-4
     codes for everywhere else. FIPS and ISO share a numeric namespace WITHOUT sharing meaning:
     FIPS CN "23" is not ISO CN-23 (Heilongjiang), and FIPS DE "06" is not any DE-xx id. Accepting
     a bare code outside US/CA would therefore paint and name the wrong province with complete
     confidence — silently. So the bare-code shortcut is allowed only where the two systems are
     known to coincide; everything else must earn its answer through geometry. */
  var BARE_CODE_OK = { US: 1, CA: 1 };
  /* geometry-resolved regions: "CN|10" -> "CN-43". Populated at render time, never guessed. */
  var RESOLVED = {};
  function regRaw(cc,code){ var m=REG[cc]; return (m&&m[code])||null; }   // static table only

  /* A stored region -> the submap's path id. MaxMind stores the region CODE ("CA"), not the name
     ("California"), so a lookup that only understands full ids and full names matches nothing and
     the whole map paints grey. Returns null rather than a maybe — the caller falls back to
     geometry, which is exact. */
  function subCode(cc,name){
    var r=SUBMAP[cc]; if(!r||name==null) return null;
    var n=String(name).trim(); if(!n) return null;
    var up=n.toUpperCase();
    if(r.c2n[up]) return up;                                        // already a submap id: "US-CA"
    if(BARE_CODE_OK[cc] && r.c2n[cc+"-"+up]) return cc+"-"+up;      // US/CA only: "CA" -> "US-CA"
    var byName=r.n2c[normName(n)]; if(byName) return byName;        // a human name: "California"
    var disp=regRaw(cc,n);                                          // "CA" -> "California" -> US-CA
    if(disp&&disp!==n){ var c=r.n2c[normName(disp)]; if(c) return c; }
    var cached=RESOLVED[cc+"|"+n]; if(cached) return cached;        // resolved earlier by geometry
    return null;
  }
  /* Fallback for the codes the registry cannot know. MaxMind stores FIPS codes for most countries
     outside the US/CA ("07" = Noord-Holland), which match no submap id. Rather than ship a
     fabricated FIPS->ISO table, ask the geometry: lat/lon is already stored per region, so project
     the point and find the path it falls inside. No invented lookup data, and it works for every
     country that has a submap. Returns null on any browser that cannot do the maths. */
  function codeAtLatLon(lat,lon){
    if(!VMAP||!CUR_STAGE||lat==null||lon==null) return null;
    var pos; try{ pos=VMAP.coordsToPoint(+lat,+lon); }catch(e){ return null; }
    if(!pos) return null;
    var svg=CUR_STAGE.querySelector("svg"); if(!svg||!svg.createSVGPoint) return null;
    var rect=CUR_STAGE.getBoundingClientRect();
    var sx=rect.left+pos.x, sy=rect.top+pos.y;
    var paths=CUR_STAGE.querySelectorAll("path[data-code]");
    for(var i=0;i<paths.length;i++){
      var el=paths[i]; if(!el.isPointInFill) return null;
      var ctm; try{ ctm=el.getScreenCTM(); }catch(e){ continue; }
      if(!ctm) continue;
      var pt=svg.createSVGPoint(); pt.x=sx; pt.y=sy;
      var loc=pt.matrixTransform(ctm.inverse());
      var q=svg.createSVGPoint(); q.x=loc.x; q.y=loc.y;
      try{ if(el.isPointInFill(q)) return el.getAttribute("data-code"); }catch(e){}
    }
    return null;
  }
  function subName(cc,code){ var r=SUBMAP[cc]; return (r&&r.c2n[code])||code; }

  var VMAP=null, LASTDRAW={level:"continent",rows:null}, RO=null, ONRESOLVE=null;
  var FOCUSED_CITY=null, LAST_SUB_VALUES={}, SUB_ROWS=[], CUR_STAGE=null, CUR_VALUES=null;
  function MET(){ var m=q("metric"); return (m&&m.value)||"visitors"; }
  function metNoun(n){ var x=(+n||0); return x.toLocaleString()+" "+(MET()==="visitors"?"visitor":"pageview")+((x===1)?"":"s"); }
  function metVal(r){ return +(MET()==="visitors"?r.visitors:r.pageviews)||0; }
  function vmDestroy(){ if(VMAP){ try{VMAP.destroy();}catch(e){} VMAP=null; } }
  function mapStage(){ var wrap=q("map"); if(!wrap) return null; wrap.innerHTML='<div class="gm-stage"></div>'; return wrap.querySelector(".gm-stage"); }
  function fitSoon(stage){ [40,180,450].forEach(function(ms){ setTimeout(function(){ if(VMAP){ try{VMAP.updateSize();}catch(e){} } paintRegions(); },ms); });
    if(window.ResizeObserver){ if(RO){try{RO.disconnect();}catch(e){}} RO=new ResizeObserver(function(){ if(VMAP){ try{VMAP.updateSize();}catch(e){} paintRegions(); } }); try{RO.observe(stage);}catch(e){} } }
  /* One pair of marker handlers for the whole page. Markers now come from two places — the level's
     own rows (region/city fallback) and the city-pin overlay — and jsVectorMap only accepts handlers
     at construction time, so they have to dispatch on the marker itself rather than on which code
     path built it. The index we are handed is jsVectorMap's key, NOT our array position: a marker
     whose coords fall outside the current map is silently skipped, so the two drift apart the moment
     one pin is off-screen. Read the config back off the map and there is nothing to drift. */
  function markerCfg(idx){
    try { var m = VMAP && VMAP._markers && VMAP._markers[idx]; if (m && m.config) return m.config; } catch(e){}
    return MARKERS[idx] || null;
  }
  /* `markers: []` is load-bearing, not decoration. jsVectorMap only creates its markers <g> when a
     markers option is present at construction (`t.markers && (this._markersGroup = ...)`), and any
     marker added later without that group falls through canvas._add's default and is appended to
     jvm-regions-group — which already carries transform="scale(s) translate(tx,ty)". Marker cx/cy
     are produced by coordsToPoint(), which has ALREADY applied scale and translate, so the pin gets
     transformed twice and the whole cloud collapses toward the top-left. An empty array is truthy,
     so this creates the group and adds nothing. Proven in tools/proof/geo_pin_projection_proof.mjs. */
  function baseOpts(stage){ return {selector:stage,markers:[],zoomButtons:true,zoomOnScroll:true,zoomMax:12,backgroundColor:"transparent",
    regionStyle:{initial:{fill:GRAY,stroke:"#FFFFFF","stroke-width":0.5},hover:{fill:HOVER},selected:{fill:HOVER}},
    onMarkerTooltipShow:function(e,tt,idx){ var m=markerCfg(idx); if(!m) return;
      tt.text(m._dot ? dotTip(m) : ("<b>"+esc(m.name)+"</b><br>"+metNoun(m._v)), true); },
    onMarkerClick:function(e,idx){ var m=markerCfg(idx); if(!m) return;
      if(m._dot){ FOCUSED_CITY=m._city; styleMarkers(); showCityVisitors(m._city,m._cc,m._reg,dotLabel(m)); return; }
      FOCUSED_CITY=m.name; styleMarkers(); showCityVisitors(m.name);
      if(window.GSGeoMapOnCity) window.GSGeoMapOnCity(m,STATE); }}; }
  var C0=[227,237,251], C1=[31,95,208], GRAY="#E9EDF3", HOVER="#C7DBF5";
  function blueAt(t){ t=Math.max(0,Math.min(1,t)); function m(i){return Math.round(C0[i]+(C1[i]-C0[i])*t);} return "rgb("+m(0)+","+m(1)+","+m(2)+")"; }
  function paintRegions(){ if(!CUR_STAGE) return; var vals=CUR_VALUES||{}, max=0, k; for(k in vals){ if(vals[k]>max) max=vals[k]; }
    var paths=CUR_STAGE.querySelectorAll("path[data-code]"); if(!paths.length) return;
    for(var i=0;i<paths.length;i++){ var p=paths[i], code=p.getAttribute("data-code"), v=vals[code]||0;
      var col=(v>0&&max>0)?blueAt(Math.pow(v/max,0.45)):GRAY;
      p.setAttribute("fill",col); p.style.fill=col; p.setAttribute("data-bf",col);
      if(!p._gh){ p._gh=1; p.addEventListener("mouseenter",function(){ this.style.fill=HOVER; }); p.addEventListener("mouseleave",function(){ this.style.fill=this.getAttribute("data-bf")||GRAY; }); } } }
  function updateSubSel(){ var sel=q("statesel"); if(!sel) return; var SM=subFor(STATE.country);
    if(!SM || !SUB_ROWS.length){ sel.hidden=true; sel.innerHTML=""; return; }
    var rows=SUB_ROWS.slice().sort(function(a,b){return metVal(b)-metVal(a);}); sel.hidden=false;
    sel.innerHTML='<option value="">'+T("geo.jump_region")+'</option>'+rows.map(function(r){ return '<option value="'+esc(r.name)+'"'+(STATE.region===r.name?' selected':'')+'>'+esc(regionName(STATE.country,r.name))+' ('+metVal(r)+')</option>'; }).join(""); }

  function drawMap(level, rows){
    rows=rows||[]; LASTDRAW={level:level,rows:rows}; if(level!=="city") FOCUSED_CITY=null;
    if(!window.jsVectorMap){ if(level==="country") renderBubble(rows); return; }
    var stage=mapStage(); if(!stage) return; CUR_STAGE=stage; vmDestroy();
    var base=baseOpts(stage);

    var want;
    if (level==="continent")   want="continents-merc";
    else if (level==="country") want=contMap(STATE.continent) || "world";
    else                        want=(subFor(STATE.country)||{}).map || "world";

    ensureMap(want).then(function(ok){
      var mapName = ok ? want : "world";
      try{
      if(level==="continent"){
        var vals={}; SUB_ROWS=[];
        rows.forEach(function(r){ if(CONT[r.code] && CONT[r.code].map!==null) vals[r.code]=metVal(r); });
        CUR_VALUES=vals;
        VMAP=new jsVectorMap(Object.assign(base,{map:mapName,
          onRegionTooltipShow:function(e,tt,code){ var row=rows.filter(function(x){return x.code===code;})[0];
            tt.text("<b>"+esc(contName(code))+"</b><br>"+(row?metNoun(metVal(row)):T('geo.no_visits')),true); },
          onRegionClick:function(e,code){ var row=rows.filter(function(x){return x.code===code;})[0]; if(row&&row.drill) drillTo("country",code); }}));
      } else if(level==="country"){
        var cvals={}; SUB_ROWS=[];
        rows.forEach(function(r){ cvals[String(r.country).toUpperCase()]=metVal(r); }); CUR_VALUES=cvals;
        VMAP=new jsVectorMap(Object.assign(base,{map:mapName,
          onRegionTooltipShow:function(e,tt,code){ var row=rows.filter(function(x){return String(x.country).toUpperCase()===code;})[0];
            tt.text("<b>"+esc(cname(code))+"</b><br>"+(row?metNoun(metVal(row)):T('geo.no_visits')),true); },
          onRegionClick:function(e,code){ if(cvals[code]>0) drillTo("region",STATE.continent,code); }}));
        // world fallback (no map for this continent): frame the countries we actually have
        if(mapName==="world"){ var fc=rows.map(function(r){return String(r.country).toUpperCase();}).slice(0,12);
          if(fc.length) try{ VMAP.setFocus({regions:fc,animate:true}); }catch(e){} }
      } else if(level==="region" && subFor(STATE.country) && mapName!=="world"){
        SUB_ROWS=rows.slice();
        var v2={},by={},unmapped=[];
        rows.forEach(function(r){
          var c=subCode(STATE.country,r.name);
          if(c){ v2[c]=(v2[c]||0)+metVal(r); by[c]=r; } else if(r.lat!=null&&r.lon!=null){ unmapped.push(r); }
        });
        LAST_SUB_VALUES=v2; CUR_VALUES=v2;
        VMAP=new jsVectorMap(Object.assign(base,{map:mapName,
          onRegionTooltipShow:function(e,tt,code){ var r=by[code]; tt.text("<b>"+esc(subName(STATE.country,code))+"</b><br>"+(r?metNoun(metVal(r)):T('geo.no_visits')),true); },
          onRegionClick:function(e,code){ var r=by[code]; if(r) drillTo("city",STATE.continent,STATE.country,r.name); }}));
        // Tier 2: anything the registry could not name, place by geometry once the map exists.
        // Tier 3: if that still leaves the map blank, markers from lat/lon beat a grey country.
        if(unmapped.length) setTimeout(function(){
          var got=0;
          unmapped.forEach(function(r){
            var c=codeAtLatLon(r.lat,r.lon);
            if(c){ RESOLVED[STATE.country+"|"+r.name]=c; v2[c]=(v2[c]||0)+metVal(r); if(!by[c]) by[c]=r; got++; }
          });
          if(got){
            LAST_SUB_VALUES=v2; CUR_VALUES=v2; paintRegions(); updateSubSel();
            // the table/board were drawn before geometry ran and are showing raw FIPS codes;
            // redraw them now that those codes have real province names behind them
            if(ONRESOLVE) try{ ONRESOLVE(); }catch(e){}
          }
          if(!Object.keys(v2).length) drawMarkers(level,rows);
        },80);
      } else {
        drawMarkers(level,rows);
      }
      paintRegions(); updateSubSel(); fitSoon(stage); syncDots();
      }catch(err){ if(level==="country") renderBubble(rows); }
    });
  }
  var MARKERS=[];
  /* lat/lon markers: the city view, and the fallback whenever a choropleth cannot be built. */
  function drawMarkers(level,rows){
    var stage=CUR_STAGE||mapStage(); if(!stage) return; CUR_STAGE=stage; vmDestroy();
    var SM=subFor(STATE.country);
    MARKERS=rows.filter(function(x){return x.lat!=null&&x.lon!=null;}).map(function(x){
      return {name:(level==="city"?x.name:regionName(STATE.country,x.name)),coords:[+x.lat,+x.lon],_v:metVal(x),_dot:0}; });
    var mn=(SM&&mapReady(SM.map)&&LOADEDMAPS[SM.map])?SM.map:"world";
    CUR_VALUES=(mn!=="world")?LAST_SUB_VALUES:null;
    VMAP=new jsVectorMap(Object.assign(baseOpts(stage),{map:mn,markers:MARKERS,
      markerStyle:{initial:{fill:"#1F5FD0",stroke:"#fff","stroke-width":1.4,r:6},hover:{fill:"#14489E"}}}));
    try{ if(mn!=="world"&&level==="city"&&subCode(STATE.country,STATE.region)) VMAP.setFocus({regions:[subCode(STATE.country,STATE.region)],animate:true});
         else if(STATE.country) VMAP.setFocus({regions:[STATE.country],animate:true}); }catch(e){}
    paintRegions(); setTimeout(styleMarkers,80); syncDots();
  }
  function styleMarkers(){ if(!CUR_STAGE) return; var cs=CUR_STAGE.querySelectorAll("circle[data-index]");
    for(var i=0;i<cs.length;i++){ var el=cs[i], cfg=markerCfg(el.getAttribute("data-index")); if(!cfg) continue;
      if(cfg._dot){ stylePin(el,cfg); continue; }
      if(cfg.name&&cfg.name===FOCUSED_CITY){ el.setAttribute("fill","#1FA463"); el.setAttribute("r","8"); el.classList.add("gm-pulse"); }
      else { el.setAttribute("fill","#1F5FD0"); el.classList.remove("gm-pulse"); } } }

  /* ---- city pins (T("geo.th.cities") overlay) --------------------------------------------------------
     The choropleth answers "which countries"; the pins answer "which towns". lat/lon has been
     stored per session since migration 025 and until now only one view read it: the city level,
     which you could reach only by picking a continent, then a country, then a region. The overlay
     asks the same question at whatever level you are already looking at — including the world,
     where "every town this site has ever been visited from" was previously unanswerable.

     Rows are cached per scope+range, so re-drawing the map (metric switch, zoom, the region
     geometry fallback) re-pins from memory instead of re-querying. The metric is deliberately NOT
     part of the cache key: it only changes the radius, which is computed at paint time. */
  var DOTS = [], DOTS_KEY = null, DOTS_SEQ = 0, DOTS_META = null;
  var DOTS_ON = (function(){ try { return localStorage.getItem("gs_geo_dots") === "1"; } catch(e){ return false; } })();
  var PIN = "#1FA463", PIN_HOVER = "#14804A", PIN_ON = "#D97706";

  function dotsScope(){ return { continent: STATE.continent || null, country: STATE.country || null, region: STATE.region || null }; }
  function dotsKey(){ var sc = dotsScope(); return [STATE.level, sc.continent||"", sc.country||"", sc.region||"", RANGE.from, RANGE.to].join("|"); }
  function dotsUrl(){
    var sc = dotsScope(), u = "/plugin/geo/dots?" + siteParam() + "&from=" + RANGE.from + "&to=" + RANGE.to;
    if (sc.continent) u += "&continent=" + encodeURIComponent(sc.continent);
    if (sc.country)   u += "&country="   + encodeURIComponent(sc.country);
    if (sc.region)    u += "&region="    + encodeURIComponent(sc.region);
    return u;
  }
  function dotLabel(m){
    var place = [m._regName || "", m._cc ? cname(m._cc) : ""].filter(Boolean).join(", ");
    return place ? (m._city + " (" + place + ")") : m._city;
  }
  function dotTip(m){ return "<b>" + esc(m._city) + "</b><br>" + esc([m._regName||"", m._cc?cname(m._cc):""].filter(Boolean).join(", ")) + "<br>" + metNoun(m._v); }

  /* Pure: rows + metric -> jsVectorMap markers. Exposed for the proof harness, which can then
     check radius/colour/payload without a map, a DOM or a network. */
  function dotMarkers(rows, metric){
    rows = rows || []; metric = metric || "visitors";
    function val(r){ return +(metric === "visitors" ? r.visitors : r.pageviews) || 0; }
    var max = 0; rows.forEach(function(r){ var v = val(r); if (v > max) max = v; });
    var out = [];
    rows.forEach(function(r){
      if (r.lat == null || r.lon == null) return;          // never pin a place we cannot place
      var v = val(r), rad = max > 0 ? 3.4 + Math.sqrt(v / max) * 6.6 : 4;
      var city = r.city || r.name || ""; if (!city) return;
      out.push({
        name: city, coords: [+r.lat, +r.lon],
        _dot: 1, _city: city, _cc: r.country || "", _reg: r.region || "",
        _regName: r.region_name || r.region || "", _v: v,
        style: { initial: { fill: PIN, fillOpacity: 0.85, stroke: "#FFFFFF", strokeWidth: 1.2, strokeOpacity: 1, r: Math.round(rad * 10) / 10 },
                 hover:   { fill: PIN_HOVER, cursor: "pointer" } }
      });
    });
    return out;
  }
  function stylePin(el, cfg){
    var on = cfg._city && cfg._city === FOCUSED_CITY;
    el.setAttribute("fill", on ? PIN_ON : PIN);
    el.classList.toggle("gm-pulse", !!on);
  }
  /* Remove ONLY the pins. removeMarkers() with no argument takes every marker with it, including
     the region markers this level drew itself. */
  function clearDots(){
    if (!VMAP || !VMAP._markers) return;
    var keys = [];
    try { Object.keys(VMAP._markers).forEach(function(k){ var c = VMAP._markers[k] && VMAP._markers[k].config; if (c && c._dot) keys.push(k); }); } catch(e){}
    if (keys.length) { try { VMAP.removeMarkers(keys); } catch(e){} }
  }
  function setDotsNote(t){ var el = q("dots-note"); if (el) { el.textContent = t || ""; el.hidden = !t; } }
  function dotsNote(){
    var d = DOTS_META || {}, n = +d.shown || 0, parts = [];
    parts.push(n ? (n.toLocaleString() + " " + (n === 1 ? T("geo.city_one") : T("geo.city_many")) + " " + T("geo.pinned")) : T("geo.no_city"));
    if (d.truncated) parts.push("top " + n.toLocaleString() + " of " + (+d.located || 0).toLocaleString());
    var u = d.unlocated || {};
    if (u.cities) parts.push(u.cities.toLocaleString() + " more have no coordinates");
    return parts.join(" \u00b7 ");
  }
  function updateDotsBtn(){
    var b = q("dots"); if (!b) return;
    var off = (STATE.level === "city");             // the city level IS pins; the toggle is noise there
    b.hidden = off;
    b.classList.toggle("on", DOTS_ON && !off);
    b.setAttribute("aria-pressed", (DOTS_ON && !off) ? "true" : "false");
  }
  function paintDots(){
    clearDots();
    if (!DOTS_ON || !VMAP || STATE.level === "city") { setDotsNote(""); return; }
    var list = dotMarkers(DOTS, MET());
    if (list.length) { try { VMAP.addMarkers(list); } catch(e){} }
    setDotsNote(dotsNote());
    setTimeout(styleMarkers, 0);
  }
  function loadDots(){
    var key = dotsKey();
    if (DOTS_KEY === key) { paintDots(); return; }
    var seq = ++DOTS_SEQ;
    setDotsNote(T("geo.loading_cities"));
    GS.api(dotsUrl()).then(function(r){
      if (seq !== DOTS_SEQ) return;                 // a newer scope already won the race
      var d = unwrap(r) || {};
      DOTS = d.rows || []; DOTS_META = d; DOTS_KEY = key;
      paintDots();
    }).catch(function(){
      if (seq !== DOTS_SEQ) return;
      DOTS = []; DOTS_META = null; DOTS_KEY = null; setDotsNote(T("geo.err_cities"));
    });
  }
  /* Called after every map build: jsVectorMap is destroyed and recreated on each draw, so pins
     have to be put back rather than assumed to have survived. */
  function syncDots(){
    updateDotsBtn();
    if (!DOTS_ON || STATE.level === "city") { setDotsNote(""); return; }
    loadDots();
  }
  function initDots(){
    var b = q("dots"); updateDotsBtn(); if (!b) return;
    b.addEventListener("click", function(){
      DOTS_ON = !DOTS_ON;
      try { localStorage.setItem("gs_geo_dots", DOTS_ON ? "1" : "0"); } catch(e){}
      updateDotsBtn();
      if (DOTS_ON) loadDots(); else { clearDots(); setDotsNote(""); }
    });
  }

  /* `cc`/`region` are explicit because a city pin can now be clicked from the world view, where
     STATE.country is null — reading the place off STATE would ask the server for the visitors of a
     city in no country and get an empty list back, silently. */
  /* GEO-TOWN-MODAL START — clicking a city name opens the same free Wikipedia town summary the
     Visitor Intelligence avatar uses (key-less, CORS-enabled). Graceful when a town has no page. */
  function gmWikiFetch(tries,i,cb){
    if(i>=tries.length){ cb(null); return; }
    var url="https://en.wikipedia.org/api/rest_v1/page/summary/"+encodeURIComponent(tries[i])+"?redirect=true";
    fetch(url,{headers:{Accept:"application/json"}}).then(function(r){ if(!r.ok) throw 0; return r.json(); }).then(function(j){
      var t=(j&&j.type)||"";
      if(j&&(j.extract||j.title)&&t.indexOf("disambiguation")<0&&t.indexOf("not_found")<0){ cb(j); }
      else gmWikiFetch(tries,i+1,cb);
    }).catch(function(){ gmWikiFetch(tries,i+1,cb); });
  }
  function gm_wikiModal(display, tries){
    if(!display) return;
    var ov=document.createElement("div"); ov.className="gm-town-ov";
    ov.innerHTML='<div class="gm-town" role="dialog" aria-modal="true"><button class="gm-town-x" aria-label="'+TT('geo.at.close')+'">\u00d7</button><div class="gm-town-body"><div class="gm-town-load">Looking up '+esc(display)+'\u2026</div></div></div>';
    document.body.appendChild(ov);
    function close(){ if(ov.parentNode) ov.parentNode.removeChild(ov); document.removeEventListener("keydown",onKey); }
    function onKey(e){ if(e.key==="Escape") close(); }
    document.addEventListener("keydown",onKey);
    ov.addEventListener("click",function(e){ if(e.target===ov) close(); });
    ov.querySelector(".gm-town-x").addEventListener("click",close);
    var body=ov.querySelector(".gm-town-body");
    gmWikiFetch(tries,0,function(data){
      if(!data){ body.innerHTML='<div class="gm-town-none"><div class="gm-town-h">'+esc(display)+'</div><p class="gm-town-p">No Wikipedia information is available for '+esc(display)+'.</p></div>'; return; }
      var thumb=data.thumbnail&&data.thumbnail.source?'<img class="gm-town-img" src="'+esc(data.thumbnail.source)+'" alt="">':"";
      var url=(data.content_urls&&data.content_urls.desktop&&data.content_urls.desktop.page)||("https://en.wikipedia.org/wiki/"+encodeURIComponent(String(data.title||display).replace(/ /g,"_")));
      body.innerHTML='<div class="gm-town-h">'+esc(data.title||display)+'</div>'+thumb+'<p class="gm-town-p">'+esc(data.extract||"")+'</p>'+
        '<div class="gm-town-f"><a href="'+esc(url)+'" target="_blank" rel="noopener noreferrer">Read on Wikipedia \u2197</a><span class="gm-town-attr">From Wikipedia \u00b7 CC BY-SA</span></div>';
    });
  }
  function gmTownModal(city,region,country){
    if(!city) return;
    var tries=[city]; if(region&&region!==city) tries.push(city+", "+region); if(country) tries.push(city+", "+country);
    gm_wikiModal(city, tries);
  }
  function gmRegionModal(name,countryCode,countryName){
    if(!name) return; var tries;
    if(countryCode==="US") tries=[name+" (U.S. state)", name, name+", United States"];
    else if(countryCode==="CA") tries=[name, name+" (Canada)", name+", Canada"];
    else tries=countryName?[name, name+", "+countryName]:[name];
    gm_wikiModal(name, tries);
  }
  function gmCountryModal(name){ if(!name) return; gm_wikiModal(name, [name]); }
  /* GEO-TOWN-MODAL END */

  function showCityVisitors(city,cc,region,label){
    var panel=q("visitors"); if(!panel) return;
    cc = cc || STATE.country || ""; region = (region==null ? (STATE.region||"") : region);
    panel.hidden=false;
    panel.innerHTML='<div class="gm-vh"><span>'+T("geo.visitors_from")+' <a href="#" class="gm-town-link" title="'+TT('geo.tip_wiki')+'">'+esc(label||city)+' <i class="bi bi-info-circle"></i></a> <span class="gm-vsub">('+T('geo.bots_excluded')+')</span></span><button class="gm-vclose" type="button" aria-label="'+TT('geo.at.close')+'">\u00d7</button></div><div class="gm-vbody"><div class="gm-vload">'+T("geo.loading_visitors")+'</div></div>';
    panel.querySelector(".gm-vclose").onclick=function(){ panel.hidden=true; };
    var __tl=panel.querySelector(".gm-town-link"); if(__tl){ __tl.addEventListener("click",function(e){ e.preventDefault(); gmTownModal(city, region, cc); }); }
    try{ panel.scrollIntoView({behavior:"smooth",block:"nearest"}); }catch(e){}
    if(!cc){ panel.querySelector(".gm-vbody").innerHTML='<div class="gm-vempty">'+T("geo.city_no_country")+'</div>'; return; }
    var url="/plugin/geo/visitors?"+siteParam()+"&country="+encodeURIComponent(cc)+"&region="+encodeURIComponent(region||"")+"&city="+encodeURIComponent(city)+"&from="+RANGE.from+"&to="+RANGE.to;
    GS.api(url).then(function(r){
      var d=unwrap(r), rows=d.rows||[], body=panel.querySelector(".gm-vbody");
      if(!rows.length){ body.innerHTML='<div class="gm-vempty">'+T('geo.no_nonbot_pre')+' '+esc(city)+' '+T('geo.no_nonbot_post')+'</div>'; return; }
      body.innerHTML='<div class="gm-vlist">'+rows.map(function(v){
        var meta=[v.device,v.browser,v.os].filter(Boolean).join(" \u00b7 ");
        var dates=(v.first_seen||v.last_seen)?('<span class="gm-vdates"><i class="bi bi-calendar3"></i> '+T('geo.vfirst')+' '+esc(fmtDate(v.first_seen))+' \u00b7 '+T('geo.vlast')+' '+esc(fmtDate(v.last_seen))+'</span>'):'';
        return '<div class="gm-vrow"><div class="gm-vleft"><span class="gm-vavatar">'+esc((v.short||(v.vid||"?")).slice(0,2).toUpperCase())+'</span>'+
          '<span class="gm-vtext"><span class="gm-vid">'+esc(v.short||(v.vid||"").slice(0,8))+'</span><span class="gm-vmeta">'+esc(meta||"\u2014")+'</span>'+dates+'</span></div>'+
          '<span class="gm-vstats">'+(+v.sessions||0)+' '+T('geo.vsess')+' \u00b7 '+(+v.pageviews||0)+' '+T('geo.vpv')+'</span>'+
          '<a class="gm-vopen" href="/visitor-intelligence?id='+encodeURIComponent(v.vid)+'">'+T("geo.open_vi")+'</a></div>';
      }).join("")+'</div>';
    }).catch(function(){ panel.querySelector(".gm-vbody").innerHTML='<div class="gm-vempty">'+T("geo.err_visitors")+'</div>'; });
  }

  function focusPlace(key){ // click a list row -> highlight/zoom on the map
    if(!VMAP) return;
    if(LASTDRAW.level==="continent"){ if(CONT[key]&&CONT[key].map!==null){ try{VMAP.setFocus({regions:[key],animate:true});}catch(e){} } return; }
    if(LASTDRAW.level==="country"){ try{VMAP.setFocus({regions:[key],animate:true});}catch(e){} return; }
    if(LASTDRAW.level==="region" && subFor(STATE.country)){ var code=subCode(STATE.country,key); if(code){ try{VMAP.setFocus({regions:[code],animate:true});}catch(e){} } return; }
    var m=MARKERS.filter(function(x){return x.name===key;})[0]; if(m){ FOCUSED_CITY=key; styleMarkers(); try{VMAP.setFocus({coords:m.coords,scale:6,animate:true});}catch(e){} showCityVisitors(key); }
  }

  function renderBubble(rows) { // no-jsVectorMap fallback, country level only
    var wrap = q("map"); if (!wrap) return; wrap.innerHTML = "";
    var svg = A(E("svg"), { viewBox: "0 0 " + MW + " " + MH, preserveAspectRatio: "xMidYMid meet" });
    svg.appendChild(A(E("rect"), { x: 0, y: 0, width: MW, height: MH, rx: 10, class: "geo-ocean" }));
    for (var lon = -180; lon <= 180; lon += 30) svg.appendChild(A(E("line"), { x1: px(lon), y1: 0, x2: px(lon), y2: MH, class: "grat" }));
    for (var lat = -90; lat <= 90; lat += 30) svg.appendChild(A(E("line"), { x1: 0, y1: py(lat), x2: MW, y2: py(lat), class: "grat" }));
    var max = rows.reduce(function (m, r) { return Math.max(m, r.visitors); }, 0) || 1;
    rows.slice().reverse().forEach(function (r) {
      var c = C[String(r.country).toUpperCase()]; if (!c) return;
      var rad = 4 + Math.sqrt(r.visitors) / Math.sqrt(max) * 22;
      var cir = A(E("circle"), { cx: px(c[0]), cy: py(c[1]), r: Math.max(4, Math.min(28, rad)), class: "bub" });
      cir.addEventListener("mousemove", function (e) { showTip("<b>" + flag(r.country) + " " + esc(cname(r.country)) + "</b><br>" + r.visitors.toLocaleString() + " visitors", e.clientX, e.clientY); });
      cir.addEventListener("mouseleave", hideTip);
      cir.addEventListener("click", function () { drillTo("region", STATE.continent, r.country); });
      svg.appendChild(cir);
    });
    wrap.appendChild(svg);
  }
  function showTip(html, x, y) { tip.innerHTML = html; tip.classList.add("show"); var w = tip.offsetWidth, h = tip.offsetHeight, a = x + 14, b = y + 14; if (a + w > innerWidth - 8) a = x - w - 14; if (b + h > innerHeight - 8) b = y - h - 14; tip.style.left = a + "px"; tip.style.top = b + "px"; }
  function hideTip() { tip.classList.remove("show"); }

  /* ---- rows -> a single shape the board/table both render ---- */
  function normalize(rows, level, country) {
    var mapped = rows.map(function (r) {
      if (level === "continent") return { key: r.code, label: r.name, flag: contEmoji(r.code), drill: !!r.drill, note: r.partial ? "registry region \u00b7 not drillable" : (r.countries ? r.countries + (r.countries === 1 ? " country" : " countries") : ""), m: r };
      if (level === "country")   return { key: r.country, label: cname(r.country), flag: flag(r.country), drill: true, note: "", m: r };
      if (level === "region")    return { key: r.name, label: regionName(country, r.name), flag: "", drill: true, note: "", m: r };
      return { key: r.name, label: r.name, flag: "", drill: false, note: "", m: r };
    });
    // Fold rows that render the SAME display label into one (two geo sources store a region as a
    // name AND a code, and regionName() resolves both to the same label -> visible duplicate rows).
    // Merge on the normalised label so "Noord-Holland" and "NH" (which displays as Noord-Holland)
    // become one row with summed metrics. Applies at region and city level.
    if (level !== "region" && level !== "city") return mapped;
    var byLabel = {}, order = [];
    mapped.forEach(function (it) {
      var lk = String(it.label || "").trim().toLowerCase().replace(/[\s\-_.]+/g, "");
      if (!byLabel[lk]) { byLabel[lk] = it; order.push(lk); }
      else {
        var a = byLabel[lk].m, b = it.m;
        a.visitors  = (+a.visitors  || 0) + (+b.visitors  || 0);
        a.sessions  = (+a.sessions  || 0) + (+b.sessions  || 0);
        a.pageviews = (+a.pageviews || 0) + (+b.pageviews || 0);
        // recompute derived metrics from the summed base values
        a.pages_per_visit = a.sessions ? Math.round((a.pageviews / a.sessions) * 10) / 10 : 0;
        // avg_seconds: weight by sessions
        var aw = (+a.avg_seconds || 0) * ((+a._ms || a.sessions) || 0);
        // conv_pct: weight by visitors is imperfect; recompute from converters if present, else avg
        if (a.conv != null && b.conv != null) { a.conv = (+a.conv||0)+(+b.conv||0); a.conv_pct = a.visitors ? Math.round((a.conv / a.visitors) * 1000) / 10 : a.conv_pct; }
        if (a.lat == null && b.lat != null) { a.lat = b.lat; a.lon = b.lon; }
      }
    });
    return order.map(function (lk) { return byLabel[lk]; });
  }

  function renderBoard(items, title) {
    var t = q("board-title"); if (t) t.textContent = title;
    var top = items.slice(0, 8), max = top.length ? top[0].m.visitors : 1;
    q("board").innerHTML = top.length ? top.map(function (it) {
      return '<div class="brow" data-key="'+esc(it.key)+'">' + '<span class="bflag">' + (it.flag || "") + "</span>" +
        '<span class="bname" title="' + esc(it.label) + '">' + esc(it.label) + '</span><span class="btrack"><i style="width:' +
        Math.round(it.m.visitors / (max || 1) * 100) + '%"></i></span><span class="bval">' + it.m.visitors.toLocaleString() + "</span></div>";
    }).join("") : '<div class="gs-muted small" style="padding:16px">'+TR('geo.no_data')+'</div>';
    q("board").querySelectorAll(".brow[data-key]").forEach(function(b){ b.style.cursor="pointer"; b.addEventListener("click",function(){ focusPlace(b.getAttribute("data-key")); }); });
  }

  function renderTable(items, level) {
    var colName = level === "continent" ? T("geo.th.continent") : level === "country" ? T("geo.th.country") : level === "region" ? T("geo.th.region") : T("geo.th.city");
    var head = '<thead><tr><th class="l">' + colName + '</th><th>'+T("geo.th.visitors")+'</th><th>'+T("geo.th.sessions")+'</th><th>'+T("geo.th.pageviews")+'</th><th>'+T('geo.th.pages_visit')+'</th><th>'+T('geo.th.avg_time')+'</th><th>'+T("geo.th.conv")+'</th></tr></thead>';
    function geoRow(it) {
      var m = it.m;
      var info = (level==="country"||level==="region"||level==="city") ? ' <button type="button" class="gm-info-i" data-info data-name="'+esc(it.label)+'" title="'+esc(T("geo.about_pre")+" "+it.label+" "+T("geo.about_post"))+'" aria-label="'+esc(T("geo.about_pre")+" "+it.label)+'"><i class="bi bi-info-circle"></i></button>' : "";
      return '<tr class="' + (it.drill ? "drill" : "") + '" data-key="' + esc(it.key) + '" style="cursor:pointer"><td class="l">' + (it.flag ? '<span class="bflag">' + it.flag + "</span>" : "") + esc(it.label) + info +
        (it.note ? ' <span class="g-sub">' + esc(it.note) + "</span>" : "") +
        (it.drill ? ' <i class="bi bi-chevron-right chev"></i>' : "") + "</td><td>" + m.visitors.toLocaleString() + "</td><td>" + m.sessions.toLocaleString() +
        "</td><td>" + (+m.pageviews || 0).toLocaleString() + "</td><td>" + m.pages_per_visit + "</td><td>" + secs(m.avg_seconds) + "</td><td>" + m.conv_pct + "%</td></tr>";
    }
    // The table is rebuilt each render, so the shell goes in first and the pager mounts on its
    // tbody; GSMore can't own a container that also holds the <thead>.
    var tbl = q("tbl"); tbl.innerHTML = head + "<tbody></tbody>";
    var tb = tbl.querySelector("tbody");
    if (window.GSMore) GSMore.mount({ container: tb, table: true, colspan: 7, items: items, pageSize: 20, emptyText: T("geo.no_data"), render: geoRow });
    else tb.innerHTML = items.length ? items.map(geoRow).join("") : '<tr><td colspan="7" style="padding:24px;text-align:center;color:var(--g-muted)">'+TR('geo.no_data_in_this_range')+'</td></tr>';
    q("tbl-count").textContent = items.length ? items.length + " " + colName.toLowerCase() + (items.length === 1 ? "" : "s") : "";

    // Delegated per render: `level` is captured here, and rows revealed by T('geo.load_more') are covered.
    tb.addEventListener("click", function (e) {
      var ib = e.target.closest && e.target.closest(".gm-info-i");
      if (ib) { e.stopPropagation(); var nm = ib.getAttribute("data-name");
        if (level === "country") gmCountryModal(nm);
        else if (level === "region") gmRegionModal(nm, STATE.country, cname(STATE.country));
        else gmTownModal(nm, regionName(STATE.country, STATE.region), cname(STATE.country));
        return; }
      var tr = e.target.closest && e.target.closest("tr[data-key]"); if (!tr) return;
      var key = tr.getAttribute("data-key"), drill = tr.classList.contains("drill");
      if (!drill) { focusPlace(key); return; }
      if (level === "continent") drillTo("country", key);
      else if (level === "country") drillTo("region", STATE.continent, key);
      else drillTo("city", STATE.continent, STATE.country, key);
    });
  }

  /**
   * The strip under the table. Nothing that was counted is allowed to vanish: visitors we could
   * not place get their own rows, with the reason spelled out rather than a shrug.
   */
  function renderUnresolved(list, unplaced, contCode) {
    var el = q("unres"); if (!el) return;
    var parts = [];
    if (unplaced && unplaced.visitors > 0) {
      parts.push('<div class="ur-row"><span class="ur-ic">\u25CE</span><span class="ur-t"><b>' + unplaced.visitors.toLocaleString() +
        '</b> visitor' + (unplaced.visitors === 1 ? "" : "s") + ' placed in ' + esc(contName(contCode)) + ' but in no country' +
        '<span class="ur-w">'+T("geo.continent_note")+'</span></span></div>');
    }
    (list || []).forEach(function (u) {
      if (!u.visitors) return;
      var ic = u.scope === "anonymous" ? "\u{1F576}" : u.scope === "satellite" ? "\u{1F4E1}" : "\u2753";
      parts.push('<div class="ur-row"><span class="ur-ic">' + ic + '</span><span class="ur-t"><b>' + u.visitors.toLocaleString() +
        '</b> visitor' + (u.visitors === 1 ? "" : "s") + ' \u2014 ' + esc(u.label) + '<span class="ur-w">' + esc(u.why || "") + '</span></span>' +
        '<span class="ur-v">' + (+u.pageviews || 0).toLocaleString() + ' '+T('geo.vpv')+'</span></div>');
    });
    if (!parts.length) { el.hidden = true; el.innerHTML = ""; return; }
    el.hidden = false;
    el.innerHTML = '<div class="ur-h">'+TT('geo.js.not_on_the_map')+'</div>' + parts.join("");
  }

  function renderKpis(level, items, kpis) {
    var noun = level === "continent" ? T("geo.th.continent") : level === "country" ? T("geo.th.country") : level === "region" ? T("geo.th.region") : T("geo.th.city");
    var ls = root.querySelectorAll(".kpi .l");
    ls[0].textContent = noun + " " + T("geo.k_reached_suffix");
    ls[1].textContent = T("geo.k_top_prefix") + " " + noun.toLowerCase();
    ls[3].textContent = T("geo.k_top_prefix") + "-" + noun.toLowerCase() + " " + T("geo.k_share_suffix");

    if (level === "continent" && kpis) {
      q("k-reached").textContent = (kpis.reached || 0).toLocaleString();
      q("k-top").innerHTML = kpis.top ? contEmoji(kpis.top) + " " + esc(kpis.top_name || contName(kpis.top)) : "\u2014";
      q("k-total").textContent = (kpis.total_visitors || 0).toLocaleString();
      q("k-share").innerHTML = (kpis.top_share || 0) + "<small>%</small>";
      return;
    }
    if (level === "country" && kpis) {
      q("k-reached").textContent = (kpis.reached || 0).toLocaleString();
      q("k-top").innerHTML = kpis.top_country ? flag(kpis.top_country) + " " + esc(cname(kpis.top_country)) : "\u2014";
      q("k-total").textContent = (kpis.total_visitors || 0).toLocaleString();
      q("k-share").innerHTML = (kpis.top_share || 0) + "<small>%</small>";
      return;
    }
    var total = items.reduce(function (s, it) { return s + it.m.visitors; }, 0), top = items[0];
    q("k-reached").textContent = items.length.toLocaleString();
    q("k-top").innerHTML = top ? esc(top.label) : "\u2014";
    q("k-total").textContent = total.toLocaleString();
    q("k-share").innerHTML = (total && top ? Math.round(top.m.visitors / total * 100) : 0) + "<small>%</small>";
  }

  function renderCrumbs() {
    var el = q("crumbs"); if (!el) return;
    var L = STATE.level;
    var parts = ['<span class="cr' + (L === "continent" ? " on" : "") + '" data-lvl="continent">'+T('geo.world')+'</span>'];
    if (L !== "continent") parts.push('<span class="sep"><i class="bi bi-chevron-right"></i></span><span class="cr' + (L === "country" ? " on" : "") + '" data-lvl="country">' + contEmoji(STATE.continent) + " " + esc(contName(STATE.continent)) + "</span>");
    if (L === "region" || L === "city") parts.push('<span class="sep"><i class="bi bi-chevron-right"></i></span><span class="cr' + (L === "region" ? " on" : "") + '" data-lvl="region">' + flag(STATE.country) + " " + esc(cname(STATE.country)) + "</span>");
    if (L === "city") parts.push('<span class="sep"><i class="bi bi-chevron-right"></i></span><span class="cr on">' + esc(regionName(STATE.country, STATE.region)) + "</span>");
    el.innerHTML = parts.join("");
    el.querySelectorAll(".cr[data-lvl]").forEach(function (c) {
      if (c.classList.contains("on")) return;
      c.addEventListener("click", function () {
        var lv = c.getAttribute("data-lvl");
        if (lv === "continent") drillTo("continent");
        else if (lv === "country") drillTo("country", STATE.continent);
        else if (lv === "region") drillTo("region", STATE.continent, STATE.country);
      });
    });
  }

  function drillTo(level, continent, country, region) {
    STATE.level = level;
    if (level === "continent") { STATE.continent = null; STATE.country = null; STATE.region = null; }
    if (level === "country")   { STATE.continent = continent; STATE.country = null; STATE.region = null; }
    if (level === "region")    { STATE.continent = continent; STATE.country = country; STATE.region = null; }
    if (level === "city")      { STATE.continent = continent; STATE.country = country; STATE.region = region; }
    var p = q("visitors"); if (p && level !== "city") p.hidden = true;
    writeUrl();
    load();
  }

  function migrationNote(d) {
    var note = q("note"); if (!note || !d.needs_migration) return false;
    note.hidden = false;
    note.innerHTML = '<i class="bi bi-exclamation-triangle me-1"></i>The <code>sessions.continent</code> column is missing, so traffic can\u2019t be grouped by continent. Run migration <code>034_geo_scope.sql</code> (or re-enable this plugin, which adds it) and let new traffic arrive.';
    return true;
  }

  /* A dead API used to reject with nothing attached: a blank page and an unhandled rejection in the
     console. Say it out loud instead — the note is the same strip the migration warning uses. */
  function loadFailed() {
    var note = q("note"); if (!note) return;
    note.hidden = false;
    note.innerHTML = '<i class="bi bi-exclamation-triangle me-1"></i>Couldn\u2019t load geo data \u2014 the API didn\u2019t answer. Try Refresh.';
  }

  function load() {
    if (!window.GS || !GS.site) return;
    var lvl = STATE.level, base = siteParam() + "&from=" + RANGE.from + "&to=" + RANGE.to;

    if (lvl === "continent") {
      GS.api("/plugin/geo/continents?" + base).then(function (r) {
        var d = unwrap(r); if (!d) return;
        ONRESOLVE = null; CONTINENTS = d.rows || [];
        var note = q("note"); if (note && !d.needs_migration) note.hidden = true;
        if (migrationNote(d) && !CONTINENTS.length) { drillTo("country"); return; } // fall back to the flat country view
        var items = normalize(CONTINENTS, "continent");
        drawMap("continent", CONTINENTS); renderKpis("continent", items, d.kpis);
        renderBoard(items, T("geo.top_continents")); renderTable(items, "continent");
        renderUnresolved(d.unresolved, null, null); renderCrumbs();
      }).catch(loadFailed);
      return;
    }

    if (lvl === "country") {
      var u = "/plugin/geo/countries?" + base + (STATE.continent ? "&continent=" + encodeURIComponent(STATE.continent) : "");
      GS.api(u).then(function (r) {
        var d = unwrap(r); if (!d) return;
        ONRESOLVE = null; COUNTRIES = d.countries || [];
        var items = normalize(COUNTRIES, "country");
        drawMap("country", COUNTRIES); renderKpis("country", items, d.kpis);
        renderBoard(items, STATE.continent ? T("geo.top_countries_in") + " " + contName(STATE.continent) : T("geo.top_countries"));
        renderTable(items, "country");
        renderUnresolved(d.unresolved, d.unplaced, STATE.continent); renderCrumbs();
      }).catch(loadFailed);
      return;
    }

    var url = lvl === "region"
      ? "/plugin/geo/regions?" + base + "&country=" + encodeURIComponent(STATE.country)
      : "/plugin/geo/cities?" + base + "&country=" + encodeURIComponent(STATE.country) + "&region=" + encodeURIComponent(STATE.region);
    GS.api(url).then(function (r) {
      var d = unwrap(r); if (!d) return;
      var rows = d.rows || [];
      if (d.continent && !STATE.continent) STATE.continent = d.continent;  // server's table, not a JS copy
      function paint() {
        var items = normalize(rows, lvl, STATE.country);
        renderKpis(lvl, items);
        renderBoard(items, lvl === "region" ? T("geo.top_regions") : T("geo.top_cities"));
        renderTable(items, lvl); renderCrumbs();
      }
      ONRESOLVE = (lvl === "region") ? paint : null;
      drawMap(lvl, rows); paint(); renderUnresolved(null, null, null); migrationNote(d);
      if (PENDING_CITY && lvl === "city") {
        var want = PENDING_CITY; PENDING_CITY = null;
        setTimeout(function () { if (rows.some(function (r) { return r.name === want; })) focusPlace(want); }, 260);
      }
    }).catch(loadFailed);
  }

  function _ymd(d) { return d.getUTCFullYear() + "-" + ("0" + (d.getUTCMonth() + 1)).slice(-2) + "-" + ("0" + d.getUTCDate()).slice(-2); }
  function _today() { var t = new Date(); return new Date(Date.UTC(t.getFullYear(), t.getMonth(), t.getDate())); }
  function T(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;}
  function preset(days) { var to = _today(), from = new Date(to.getTime() - (days - 1) * 86400000); var lbl = { 7: T("an.last7"), 30: T("an.last30"), 90: T("an.last90"), 365: T("an.last12mo") }[days] || T("an.lastndays",{n:days}); return { from: _ymd(from), to: _ymd(to), label: lbl, preset: String(days) }; }
  var RANGE = (function () { try { var s = JSON.parse(localStorage.getItem("gs_geo_range") || "null"); /* A stored preset is a RULE ("last 30 days"), not a fixed window. Restoring its
     absolute from/to means "last 30 days" quietly becomes "the 30 days ending whenever
     you last touched the picker" — today falls outside the range, the page looks stale,
     and Refresh re-queries the same dead window forever. Re-anchor presets to today;
     a CUSTOM range is genuinely absolute and is kept as stored. */
  if (s && s.preset) return preset(+s.preset);
  if (s && s.from && s.to) return s; } catch (e) {} return preset(30); })();
  function saveRange() { try { localStorage.setItem("gs_geo_range", JSON.stringify(RANGE)); } catch (e) {} }

  function initRange() {
    var btn = q("rangeBtn"), menu = q("rangeMenu"), lab = q("range-label"); if (!btn || !menu) return;
    if (lab && RANGE.label) lab.textContent = RANGE.label;
    function sync() { menu.querySelectorAll(".rm[data-preset]").forEach(function (x) { x.classList.toggle("on", x.getAttribute("data-preset") === RANGE.preset); }); }
    sync();
    btn.addEventListener("click", function (e) { if (menu.contains(e.target) && e.target !== btn) return; e.stopPropagation(); var open = menu.style.display !== "none"; menu.style.display = open ? "none" : "block"; if (!open) { var cf = menu.querySelector('[data-rp="from"]'), ct = menu.querySelector('[data-rp="to"]'); if (cf) cf.value = RANGE.from; if (ct) ct.value = RANGE.to; sync(); } });
    document.addEventListener("click", function () { menu.style.display = "none"; });
    menu.addEventListener("click", function (e) { e.stopPropagation(); });
    function apply(r) { RANGE = r; if (lab) lab.textContent = RANGE.label; saveRange(); menu.style.display = "none"; load(); }
    menu.querySelectorAll(".rm[data-preset]").forEach(function (b) { b.addEventListener("click", function () { apply(preset(+b.getAttribute("data-preset"))); }); });
    var ap = menu.querySelector('[data-rp="apply"]'); if (ap) ap.addEventListener("click", function () { var f = menu.querySelector('[data-rp="from"]').value, t = menu.querySelector('[data-rp="to"]').value; if (!f || !t) return; if (f > t) { var x = f; f = t; t = x; } apply({ from: f, to: t, label: f + " \u2192 " + t, preset: null }); });
  }

  function init() {
    root = document.querySelector('[data-g="root"]'); if (!root) return;
    tip = q("tip");
    var refresh = q("refresh"); if (refresh) refresh.addEventListener("click", load);
    initRange();
    document.addEventListener("gs:site-change", function () { drillTo("continent"); });
    var mSel=q("metric"); if(mSel) mSel.addEventListener("change", function(){ drawMap(LASTDRAW.level, LASTDRAW.rows||[]); });
    initDots();
    var ssel=q("statesel"); if(ssel) ssel.addEventListener("change", function(){ var v=this.value; if(v) drillTo("city",STATE.continent,STATE.country,v); });
    window.addEventListener("resize", function(){ if(VMAP) try{VMAP.updateSize();}catch(e){} });

    var deep = parseDeepLink(location.search);
    if (deep) {
      STATE.level = deep.level; STATE.continent = deep.continent;
      STATE.country = deep.country; STATE.region = deep.region;
      PENDING_CITY = deep.city;
    }
    load();
  }
  window.GS_GEO_TEST = {                                  // unit-testable surface, no DOM needed
    parseDeepLink: parseDeepLink,
    dotMarkers: dotMarkers,
    dotsUrl: function(){ return dotsUrl(); },
    dotsOn: function(){ return DOTS_ON; },
    state: STATE
  };
  ready(init);
})();
